import WorkOrderManagement from './WorkOrderManagement';

export default WorkOrderManagement;